import { render, staticRenderFns } from "./Hplc.vue?vue&type=template&id=2413ca55&scoped=true&"
import script from "./Hplc.vue?vue&type=script&lang=js&"
export * from "./Hplc.vue?vue&type=script&lang=js&"
import style0 from "./Hplc.vue?vue&type=style&index=0&id=2413ca55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413ca55",
  null
  
)

export default component.exports